<div
  class="flex flex-col"
  [ngClass]="{
    'h-screen overflow-hidden': chatOpen(),
    'min-h-screen': !chatOpen(),
  }"
  data-testid="basic-layout-shell"
>
  @let user = this.user();
  <pm-header
    [userFirstName]="user?.firstName"
    [userLastName]="user?.lastName"
    [userEmail]="user?.email"
  />
  <div class="flex flex-row flex-1 min-h-0">
    <pm-sidebar />
    <div
      class="flex flex-col flex-1 pl-12 pt-14 justify-start bg-surface-interactive-hover w-full transition-[margin] duration-200"
      [ngClass]="{ 'mr-[400px] overflow-y-auto': chatOpen() }"
    >
      <!-- content -->
      <div class="m-2 flex-1 flex flex-col gap-2">
        <pm-page-heading [isHomePage]="isHomePage()" />
        @let backgroundIsTransparent = this.backgroundIsTransparent();
        <div
          class="rounded-lg flex-1"
          [ngClass]="{
            'bg-white': !backgroundIsTransparent,
            'bg-transparent': backgroundIsTransparent,
            'px-12 py-4': isHomePage(),
            'p-4': !isHomePage(),
          }"
        >
          <router-outlet />
        </div>
      </div>
      <pm-footer />
    </div>
    @if (chatOpen()) {
      <aside
        class="fixed bottom-0 right-0 top-14 z-40 flex w-[400px] flex-col border-l border-border-subdued bg-surface shadow-[-4px_0_16px_rgba(52,62,75,0.08)]"
      >
        <pm-chat-rail />
      </aside>
    }
  </div>
</div>
